export default __webpack_public_path__ + "static/media/rateProvidersPic.ef0616e5.png";